import { Card, CardContent, CardProps, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { TableUpdateStatusCell } from "@pimo/pimo-components";
import { formatDate } from "aint-utils";
import { FC, ReactNode } from "react";

export interface OeKpisTitleCardProps {
  /** SVG icon */
  icon?: string;
  /** Title displayed to the left */
  title: string;
  /** Component displayed in the right corner */
  endSlot?: ReactNode;
  /** The date to be shown in the last updated at chip */
  lastUpdatedAt?: string;
  cardProps?: CardProps;
}

export const OeKpisTitleCard: FC<OeKpisTitleCardProps> = ({
  title,
  endSlot,
  cardProps = {},
  lastUpdatedAt,
}) => {
  return (
    <Card
      data-testid="TitleCard"
      sx={{
        borderRadius: "12px",
        boxShadow: "none",
        height: "100%",
        width: "100%",
        flex: "1 1 auto",
        "@media print": {
          border: "1px solid rgba(0, 0, 0, 0.12)",
          pageBreakBefore: "always",
        },
        ...cardProps.sx,
      }}
    >
      <CardContent
        sx={{
          height: 65,
          padding: 2,
          pb: 2,
          "&:last-child": {
            pb: 2,
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "50px",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" sx={{ textAlign: "left" }}>
            {title}
          </Typography>
          {lastUpdatedAt && (
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <TableUpdateStatusCell
                cardProps={{
                  sx: {
                    div: {
                      div: {
                        lineHeight: "initial",
                        height: "initial",
                      },
                    },
                  },
                }}
                chipColor="#00378120"
                body={`Last updated: ${formatDate(lastUpdatedAt, "YYYY/MM/DD")}`}
              />
            </Box>
          )}
        </Box>
        <Box
          sx={{
            mt: 0,
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
          }}
        >
          {endSlot}
        </Box>
      </CardContent>
    </Card>
  );
};

export default OeKpisTitleCard;
